var _line, _line2, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 137,
    viewBox: "0 0 180 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 126.278,
    y2: -2.5,
    transform: "matrix(0.712025 0.702155 -0.611871 0.790958 0 48.3333)",
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 126.278,
    y2: -2.5,
    transform: "matrix(0.712025 -0.702155 0.611871 0.790958 89.9131 137)",
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 126.278,
    y2: -2.5,
    transform: "matrix(0.712025 0.702155 -0.611871 0.790958 0 4)",
    stroke: "white",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 126.278,
    y2: -2.5,
    transform: "matrix(0.712025 -0.702155 0.611871 0.790958 89.9131 92.6667)",
    stroke: "white",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.7565f182b94ec2fa8a4a465e2fdd5981.svg";
export { ForwardRef as ReactComponent };